import { render } from "./NotFOund.vue?vue&type=template&id=fc0cce0c&scoped=true"
import script from "./NotFOund.vue?vue&type=script&lang=js"
export * from "./NotFOund.vue?vue&type=script&lang=js"

import "./NotFOund.vue?vue&type=style&index=0&id=fc0cce0c&scoped=true&lang=css"

import exportComponent from "/Users/sahanakumari/Documents/GitHub/zsurvey-app/zsurvey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc0cce0c"]])

export default __exports__